export const toUptimeNumber = value => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const isValidCustomInterval = value => {
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed >= 60;
};

export const buildUptimePayload = ({
    name,
    type,
    method,
    url,
    interval,
    customInterval,
    isCustomInterval,
    validHttpStatus,
    body,
    header
}) => ({
    name,
    type,
    method,
    url,
    interval: toUptimeNumber(interval),
    customInterval: toUptimeNumber(customInterval),
    isCustomInterval,
    validHttpStatus: toUptimeNumber(validHttpStatus),
    body,
    header
});
